/**
 * Shared source logo mapping.
 * Single source of truth for source logo assets across the app.
 */

import { getSourceName } from './sourceHelpers';

export const DEFAULT_SOURCE_LOGO = require('../assets/source-logos/default.png');

const SOURCE_LOGOS_BY_NAME: { [key: string]: any } = {
    'arxiv': require('../assets/source-logos/arxiv.png'),
    'biorxiv': require('../assets/source-logos/biorxiv.png'),
    'medrxiv': require('../assets/source-logos/medrxiv.png'),
    'chemrxiv': require('../assets/source-logos/chemrxiv.png'),
    'chinaxiv': require('../assets/source-logos/chinaxiv.png'),
    'pubmed': require('../assets/source-logos/pubmed.png'),
    'iacr': require('../assets/source-logos/iacr.png'),
    'iacr eprint': require('../assets/source-logos/iacr.png'),
};

const SOURCE_LOGOS_BY_ID: Record<number, any> = {
    1: SOURCE_LOGOS_BY_NAME['arxiv'],
    2: SOURCE_LOGOS_BY_NAME['medrxiv'],
    3: SOURCE_LOGOS_BY_NAME['biorxiv'],
    4: SOURCE_LOGOS_BY_NAME['chinaxiv'],
    5: SOURCE_LOGOS_BY_NAME['pubmed'],
    6: SOURCE_LOGOS_BY_NAME['chemrxiv'],
};

/**
 * Get the logo asset for a source by name string (e.g. "arXiv", "medRxiv").
 * Returns the matching logo or the default paperzilla favicon.
 */
export function getSourceLogoByName(sourceName: string | null | undefined): any {
    if (!sourceName) return DEFAULT_SOURCE_LOGO;
    return SOURCE_LOGOS_BY_NAME[sourceName.toLowerCase()] || DEFAULT_SOURCE_LOGO;
}

/**
 * Get the logo asset for a source by numeric ID (e.g. 1 = arXiv, 2 = medRxiv).
 * Returns the matching logo or the default paperzilla favicon.
 */
export function getSourceLogoById(sourceId: number | null | undefined): any {
    if (!sourceId) return DEFAULT_SOURCE_LOGO;
    return SOURCE_LOGOS_BY_ID[sourceId] || getSourceLogoByName(getSourceName(sourceId));
}
